import apiService from '@/services/api'

export interface LoginResponse {
  token: string
  refreshToken: string
  user: {
    id: string
    name: string
    email: string
    role: string
    avatar?: string | null
  }
}

interface ApiLoginResponse {
  success: boolean
  data: LoginResponse
  message?: string
}

/**
 * Log in with email and password.
 * Returns token, refreshToken, and user. Store token and user in localStorage
 * so the API client sends the token on subsequent requests.
 * Note: Auth will move to Okta when all apps are hosted there.
 */
export async function login(email: string, password: string): Promise<LoginResponse> {
  const res = await apiService.post<ApiLoginResponse>('auth/login', { email, password })
  if (!res.success || !res.data) {
    throw new Error(res.message || 'Login failed')
  }
  return res.data
}
